import { showHttpErrorAlertCallout } from "@/shared/utils/show-http-error-alert-callout";
import type { UserId } from "@/spz-api/model";
import { findUserGroupById } from "@/spz-api/user-groups/user-groups";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useUserGroupsForm } from "../hooks/use-user-groups-form";
import type { UserGroupsFormSchemaValues } from "./schemas/user-groups-form.schema";

export const selectUserGroupsFormViewModel = ({
  onSuccess,
  groupId,
}: {
  onSuccess?: () => void;
  groupId?: string;
}) => {
  const { t } = useTranslation();
  const userGroupsForm = useUserGroupsForm({
    groupId,
    onSuccess,
  });

  useEffect(() => {
    if (!groupId) {
      return;
    }

    findUserGroupById(groupId)
      .then((response) => {
        const userGroup = response.data;

        const initialValues: UserGroupsFormSchemaValues = {
          name: userGroup.name,
          description: userGroup.description || undefined,
          users: userGroup.userIds.map((item) => item as unknown as UserId),
          updatedAt: userGroup.updatedAt || undefined,
        };
        userGroupsForm.form.reset(initialValues);
      })
      .catch((error) => {
        showHttpErrorAlertCallout({
          error,
          defaultErrorMessage: t("group_fetch_by_id_error"),
        });
      });
  }, [t, groupId, userGroupsForm.form.reset]);

  return {
    form: userGroupsForm.form,
    onSubmit: userGroupsForm.onSubmit,
    users: userGroupsForm.users,
  };
};
